import React from 'react';
import { ArrowRightIcon, StarIcon } from 'lucide-react';
import { CHECKOUT_URL, CTAButton, PRICE, PRICE_SHORT, Section } from './Shared';
import { Bamboo, LeafSpray, LuoPan } from './Decor';
const inclusions = ['Acceso inmediato', '100% PDF', 'Garantía 7 días', 'Pago seguro'];
export function EmotionalClose() {
  return <Section className="max-w-4xl" data-id="element-77" data-mp="qm8czibw2ln7">
      {/* Cierre emocional */}
      <div className="relative overflow-hidden border-2 border-brand-wood bg-brand-woodDark p-6 text-center text-brand-rice md:p-14" data-id="element-78" data-mp="mleoonujb4ts">
        <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-79" data-mp="hlsg4rpnicrb">
          <div className="lattice absolute inset-0 opacity-[0.06]" data-id="element-80" data-mp="coa4gtk91jfm" />
          <Bamboo className="animate-drift-slow absolute -left-2 top-6 hidden h-56 w-20 text-brand-jade/30 md:block" data-id="element-81" data-mp="7oxfo39ti2ae" />
          <LeafSpray className="absolute -bottom-8 right-2 hidden h-48 w-48 text-brand-jade/20 md:block" data-id="element-82" data-mp="270gs4rubxsot" />
          <LuoPan className="animate-compass absolute -top-16 right-[-3rem] h-56 w-56 text-brand-goldLight/12" data-id="element-83" data-mp="223qcg5mfsz3x" />
        </div>

        <div className="relative" data-id="element-84" data-mp="354lty1kwb5bi">
          <h2 className="mx-auto max-w-2xl font-title text-2xl leading-tight text-brand-goldLight md:text-4xl" data-id="element-85" data-mp="3a1cbktccm8z1">
            Tu próxima etapa comienza con un espacio preparado para acompañarla
          </h2>
          <div className="mx-auto mt-6 h-1 w-20 bg-brand-gold" aria-hidden="true" data-id="element-86" data-mp="302whqilxsllu" />

          <div className="mx-auto mb-10 mt-8 max-w-2xl space-y-4 font-serif text-base leading-relaxed text-brand-rice/85 md:text-lg" data-id="element-87" data-mp="3ntaaycg9cqi0">
            <p data-id="element-88" data-mp="3sr22h5czqalo">La pregunta no es solamente cuánto cuesta el pack.</p>
            <p className="font-semibold text-white" data-id="element-89" data-mp="3e3gxf5wk21b4">
              La pregunta es cuánto tiempo más vas a mirar tu negocio sintiendo que algo no fluye sin saber qué cambiar.
            </p>
            <p className="pt-2" data-id="element-90" data-mp="amgv6lpc4kva">Hay dos versiones de vos en este momento.</p>
            <p data-id="element-91" data-mp="akdyxjxl9vi4">
              Una cierra esta página. Mañana vuelve al mismo negocio. Ve los mismos muebles, los mismos objetos
              acumulados, la misma entrada, los mismos rincones. Y sigue pensando:{' '}
              <em className="text-brand-goldLight" data-id="element-92" data-mp="ka305x18ga7y">“Algún día tendría que cambiar esto.”</em>
            </p>
            <p className="font-title text-lg not-italic text-brand-goldLight md:text-xl" data-id="element-93" data-mp="g892zyq8xocj">
              Y otra decide que hoy es el día de volver a mirar su negocio con otros ojos.
            </p>
          </div>

          {/* Oferta final */}
          <div className="mx-auto max-w-md border-2 border-brand-gold bg-brand-paper p-6 pt-9 text-brand-ink shadow-[0_18px_40px_rgba(36,28,20,0.4)]" data-id="element-94" data-mp="6b39yky2nn9o">
            <span className="relative -top-11 inline-flex items-center gap-1.5 rounded-sm bg-brand-cinnabar px-3.5 py-1 font-title text-[10px] uppercase tracking-[0.18em] text-white" data-id="element-95" data-mp="3spmrgqicfikd">
              <StarIcon className="h-3 w-3 fill-current" aria-hidden="true" data-id="element-96" data-mp="3omhpqq637kws" />
              Más elegido
            </span>
            <h3 className="-mt-6 font-title text-lg uppercase tracking-[0.08em] text-brand-jadeDeep" data-id="element-97" data-mp="3eple4bkw6io0">
              Feng Shui Negocios™
            </h3>
            <p className="mt-2 font-title text-4xl text-brand-cinnabar" data-id="element-98" data-mp="1u7uge9o99z53">{PRICE}</p>
            <p className="mb-6 mt-3 font-serif text-sm leading-relaxed text-brand-inkLight" data-id="element-99" data-mp="1z5w08wtia2hm">
              3 Tomos + 6 Bonus. Diagnóstico del espacio, activadores, apertura de caminos, Mapa Bagua, colores, curas
              rápidas, consultorios y calendario de activación.
            </p>
            <CTAButton href={CHECKOUT_URL} fullWidth className="text-xs md:text-sm" data-id="element-100" data-mp="1biw5i04q9mnm">
              Quiero acceso ya — {PRICE_SHORT}
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-101" data-mp="1gela4hvlttqs" />
            </CTAButton>
            <ul className="mt-4 flex flex-wrap justify-center gap-x-3 gap-y-1 text-[11px] text-brand-muted" data-id="element-102" data-mp="1kg6h5mlgjdt2">
              {inclusions.map(item => <li key={item} data-id="element-103" data-mp="srd23s6sk6l2">{item}</li>)}
            </ul>
          </div>

          <p className="mt-8 font-serif text-sm text-brand-rice/75 md:text-base" data-id="element-104" data-mp="spagdkco8zm5">
            El precio de lanzamiento vence hoy. Después sube. No vuelve.
          </p>
        </div>
      </div>
    </Section>;
}